// src/components/LoadingSpinner.jsx
import styles from './LoadingSpinner.module.css';

const SIZE_CLASS = {
  sm: styles.sm,
  md: styles.md,
  lg: styles.lg,
  xl: styles.xl,
};

export default function LoadingSpinner({ size = 'md', text = '' }) {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.spinner} ${SIZE_CLASS[size] ?? styles.md}`} />
      {text && <p className={styles.text}>{text}</p>}
    </div>
  );
}

export function LoadingCard() {
  return (
    <div className={styles.loadingCard}>
      <div className={styles.loadingCard__header}>
        <div className={styles.loadingCard__icon} />
        <div className={styles.loadingCard__lines}>
          <div className={`${styles.line} ${styles['line--title']}`} />
          <div className={`${styles.line} ${styles['line--sm']}`} />
        </div>
      </div>
      <div className={styles.loadingCard__body}>
        <div className={`${styles.line} ${styles['line--md']}`} />
        <div className={`${styles.line} ${styles['line--sm']}`} />
      </div>
    </div>
  );
}
